import base from './base';

export default class extends base {
    static get uri() {
        return 'card-types';
    }
}
